import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { ICreateException } from '../../../models/index';
import { getException } from '../../actions/actionType/services/ServiceActionTypes';
import { clearGetExceptionsDetails, getExceptionFailure, getExceptionStart, getExceptionSuccessful } from '../../actions/sagaActions/exceptions/GetExceptionSagaActions';
import { GetExceptionFailurePayload, GetExceptionRequest } from '../../actions/types/exceptions/GetExceptionTypes';

/**
 * Call Get metric summary by API
 * @returns api response
 */

export async function callGetExceptionApi(ersExceptionName: string) {
  return apiWrapper.get<ICreateException[]>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/exceptions/${ersExceptionName}/status/active`,
    headersInstance()
  );
}

export function* getExceptionApi({ requestObject }: GetExceptionRequest) {
  yield put(clearGetExceptionsDetails());
  yield put(getExceptionStart());
  try {
    const { responseBody: data, isError, error } = yield call(callGetExceptionApi, requestObject);
    if (isError) {
      throw error;
    }
    // put length check here
    if (data) {
      yield put(getExceptionSuccessful(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: GetExceptionFailurePayload = {
      error: String(error)
    };
    yield put(getExceptionFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* GetExceptionSaga() {
  yield takeLatest(getException.GET_EXCEPTION_REQUEST, getExceptionApi);
}

export const getExceptionDetailSaga = [fork(GetExceptionSaga)];
